import {Injectable} from '@angular/core';
import {ContractService} from './contract.service';
import {EventEmitter} from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class WarningSmsContractService {
  statusUpdated = new EventEmitter();
  constructor(private contractService: ContractService) {
  }

  getDataQuantityAndWarningQuantitySmsContractOfEnterpriseByService() {
    this.contractService.getDataCountNumberDocumentOfEnterpriseByService().pipe().subscribe(
      response => {
        this.statusUpdated.emit((response.data));
      }
    );
  }
}
